import * as R from 'ramda'
import type { Nil } from '@pbt/pbt-ui-components'

import type { Adjustment } from '~/types'

import useGetInStockAmount, {
  pickAdjustmentInStockInfo,
} from '../orders-and-receives/order-item-receipts/hooks/useGetInStockAmount'

const AdjustmentAmountCell = (item: Partial<Adjustment> | Nil) => {
  const getInStockAmount = useGetInStockAmount({
    relative: true,
    isAdjustment: true,
  })

  if (!item) {
    return null
  }

  const getAdjustmentAmount = R.pipe(
    pickAdjustmentInStockInfo,
    getInStockAmount,
  )

  return <>{getAdjustmentAmount(item)}</>
}

export default AdjustmentAmountCell
